import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { IViewColumnsEditorProps } from './IViewColumnsEditorProps';
import { moveColumn, orderedFields, toggleColumn } from './viewDraft';

/**
 * «Стовпці · атрибути» (прототип v4): рамкований список полів — прапорець, підпис, тип поля мовою інтерфейсу (моноширинний, приглушений), ↑/↓ (26px; недоступні
 * для невибраних і на краю); назва — завжди перша й увімкнена, далі вибрані в порядку показу, невибрані — напівпрозорі.
 */
export function ViewColumnsEditor({ rt, columns, onChange }: IViewColumnsEditorProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const title = rt.fields.find((f) => f.key === 'title');
  return (
    <div className="lv-vs__field">
      <span className="lv-vs__caption">{t('viewSettings.columns')}</span>
      <div className="lv-vs__cols">
        {title && (
          <div className="lv-vs__col">
            <label className="lv-vs__col-label"><input type="checkbox" checked disabled /><span>{strings.field(rt.key, 'title', title.label)}</span></label>
            <span className="lv-vs__col-type">{t(`listViews.types.${title.type}`, { defaultValue: title.type })}</span>
          </div>
        )}
        {orderedFields(rt, columns).map((f) => {
          const at = columns.indexOf(f.key);
          const label = strings.field(rt.key, f.key, f.label);
          return (
            <div key={f.key} className={cx('lv-vs__col', at < 0 && 'is-off')}>
              <label className="lv-vs__col-label">
                <input type="checkbox" checked={at >= 0} onChange={() => onChange(toggleColumn(columns, f.key))} />
                <span>{label}</span>
              </label>
              <span className="lv-vs__col-type">{t(`listViews.types.${f.type}`, { defaultValue: f.type })}</span>
              <button type="button" className="lv-vs__move" aria-label={`${t('viewSettings.moveUp')}: ${label}`} title={t('viewSettings.moveUp')} disabled={at <= 0}
                onClick={() => onChange(moveColumn(columns, f.key, -1))}>↑</button>
              <button type="button" className="lv-vs__move" aria-label={`${t('viewSettings.moveDown')}: ${label}`} title={t('viewSettings.moveDown')}
                disabled={at < 0 || at === columns.length - 1} onClick={() => onChange(moveColumn(columns, f.key, 1))}>↓</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
